import React from "react";

const TopHeader = () => {
    return (
        <div className="bg-gray-100 dark:bg-gray-700 font-redhat">
            <h3 className=" text-black dark:text-white p-2 m-0 text-center text-3xl">Dictionary App</h3>
        </div>
    );
};

export default TopHeader;
